<template>
  <div class="container">
    <p>
      LevelFi is a lead scoring tool that will help you quickly determine if
      your customer may qualify for a LiftFund loan. After filling out the
      information below, LevelFi will provide you:
    </p>
    <ul>
      <li>
        <b>A LevelFi Score:</b> A score between 0 and 1 that correlates to a
        low, moderate, or high risk of default if the borrower were to
        ultimately receive a LiftFund loan.
      </li>
      <li>
        <b>LevelFi Amount Qualified:</b> A tentative maximum amount that
        LiftFund would consider extending to the borrower based on the credit
        and business and personal financial information input. Note that a final
        loan amount will be determined by LiftFund through a full application,
        credit pull and validation of financials.
      </li>
      <li>
        <b>LevelFi Referral Recommendation:</b> LevelFi will determine if a
        LiftFund loan is a good fit for the customer based on the stated credit
        and capacity information input. If the client is a fit, LevelFI will
        recommend and enable you to securely refer the potential borrower to
        LiftFund. If they are not a good fit we recommend the client participate
        in our business support consultation services.
      </li>
    </ul>
    <h1 class="mt-5">Score an Applicant</h1>
    <p>
      Enter client information (stated or reviewed) below to get real time score
      of your referral.
    </p>
    <p>
      <img src="/static/img/info_icon.png" width="20px" /> Hover over the icon
      to understand what financial information to use in the fields.
    </p>
    <!-- <button v-tooltip="'This is the test tooltip'">Hover: Instructions Test Button</button> -->
    <div class="container mt-4">
      <form @submit.prevent="submit()">
        <!-- form of Requested Loan amount to Monthly Personal Data -->
        <div class="login-form-single-upload">
          <div v-for="param of FieldAliases" :key="param.modelField">
            <div v-if="param.preFieldNote" class="form-row field-note">
              <div class="col-sm-12">
                <label class="control-label">{{ param.preFieldNote }}</label>
              </div>
            </div>
            <!--          <div v-if="param.userInput !== 'none'" class="form-row">-->
            <div
              v-if="param.userInput !== 'none' && param.contactField != true"
              class="form-row"
            >
              <div
                :class="{
                  'col-sm-4': !param.fieldIndent,
                  'col-sm-3': param.fieldIndent,
                  'offset-sm-1': param.fieldIndent
                }"
                width="20px"
              >
                <!-- Instructions on Hover Start -->

                <label class="control-label" border="solid 3px blue">
                  {{ param.alias }}
                </label>

                <!-- Instructions on Hover End -->
                <img
                  class="info-icon"
                  v-if="param.instructions"
                  v-tooltip="param.instructions"
                  src="/static/img/info_icon.png"
                />
                <!-- Breeann - Tooltip -->
              </div>

              <div class="col-sm-8">
                <input
                  v-if="param.userInput === 'numeric'"
                  v-model="parameters[param.alias]"
                  type="number"
                  class="form-control"
                />
                <input
                  v-if="param.userInput === 'text'"
                  v-model="parameters[param.alias]"
                  type="text"
                  class="form-control"
                />
                <select
                  v-if="param.userInput === 'dropdown'"
                  v-model="parameters[param.alias]"
                  class="form-control"
                >
                  <option
                    v-for="row of enums[param.modelField]"
                    :key="row.code"
                    :value="row.name"
                  >{{ row.name }}</option
                  >
                </select>
              </div>
            </div>
          </div>

          <div v-if="errorMessage" class="form-row">
            <div class="col-sm-8 offset-sm-4">
              <div class="error-message">{{ errorMessage }}</div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <!-- <div class="calculate-clear-buttons"> -->
          <div class="col-sm-8 offset-sm-4">
            <button type="submit" class="btn btn-primary">Calculate</button>
            <button
              @click="ClearValues()"
              :disabled="Object.keys(parameters).length < 2"
              type="button"
              class="btn btn-secondary ml-3"
            >
              Clear values
            </button>
          </div>
          <!-- </div> -->
        </div>
        <br />
        <!-- Start of Levelfi Score form to Levelfi Referral Recommendation -->
        <div class="login-form-single-upload">
          <div class="form-row">
            <div class="col-sm-4">
              <label class="control-label">LevelFi Score</label>
            </div>
            <div class="col-sm-8">
              <input
                v-model="scoreResult"
                type="text"
                readonly
                class="form-control"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="col-sm-4">
              <label class="control-label">LevelFi Amount Qualified</label>
            </div>
            <div class="col-sm-8">
              <input
                v-model="ten_amount_levelfi"
                type="text"
                readonly
                class="form-control"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="col-sm-4">
              <label class="control-label"
              >LevelFi Referral Recommendation</label
              >
            </div>
            <div class="col-sm-8">
              <div v-if="rec_levelfi == 'Refer Lead'">
                <p style="color:#008000;">
                  Refer Lead: A LiftFund business loan may be a good fit for
                  this client based on stated information.
                </p>
              </div>
              <div v-if="rec_levelfi == 'Do Not Refer Lead'">
                <p style="color:#B22222;">
                  Do not refer. Based on the information shared by client a
                  LiftFund business loan may not be a good fit at this time. We
                  recommend the client visit our business support team at
                  <a href="https://www.liftfund.com/">www.liftfund.com.</a>
                </p>
              </div>
              <!--            <input v-model="rec_levelfi" type="text" readonly class="form-control">-->
            </div>
          </div>
        </div>
        <!-- <div class="form-row">
          <div class="col-sm-8 offset-sm-4">
            <button :disabled="scoreResult === undefined" @click="SaveFile()" type="button" class="btn btn-secondary">Save to file</button>
          </div >

        </div> -->

        <div id="refer-text">
          <div v-if="rec_levelfi == 'Refer Lead'">
            <!--              <p style="color:#008000;" >Refer Lead: A LiftFund business loan may be a good fit for this client. </p>-->
            <img
              src="/static/img/understandingscores.png"
              class="img-fluid understanding-scores"
              alt="Understanding scores"
            />
            <p v-html="Refer_Text"></p>
            <div
              class="add-client-contact-button"
              v-if="
                (partner_type == 'complete_submit') ||
                  (partner_type == 'partial_submit')
              "
            >
              <b-button v-b-toggle.collapse-1 variant="primary"
              >Yes, Add Client<br />Contact Information</b-button
              >
            </div>

            <b-collapse id="collapse-1" class="mt-2">
              <div v-if="display_contact" v-for="param of ContactAliases" :key="param.modelField">
                <div v-if="param.preFieldNote" class="form-row field-note">
                  <div class="col-sm-12">
                    <label class="control-label">{{
                        param.preFieldNote
                      }}</label>
                  </div>
                </div>
              </div>
              <div v-if="display_contact" class="login-form-single-upload-contact">
                <div v-for="param of ContactAliases" :key="param.modelField">
                  <div v-if="param.userInput !== 'none'" class="form-row">
                    <!--          <div v-if="param.userInput !== 'none' && param.contactField != true" class="form-row">-->
                    <div
                      :class="{
                        'col-sm-4': !param.fieldIndent,
                        'col-sm-3': param.fieldIndent,
                        'offset-sm-1': param.fieldIndent
                      }"
                    >
                      <label class="control-label">{{ param.alias }}</label>
                    </div>
                    <div class="col-sm-8">
                      <input
                        v-if="param.userInput === 'text'"
                        v-model="contact_data[param.alias]"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Gets the details for the acquisition of the lead -->
              <div class="form-row mb-4" v-if="userIsLiftFund">
                <div class="col-sm-12">
                  <label class="control-label">Where did you get this lead?</label>
                  <textarea v-model="referral_detail" class="form-control"></textarea>
                </div>
              </div>

              <div v-if="errorMessage_crm" class="form-row">
                <div class="col-sm-8 offset-sm-4">
                  <div class="error-message">{{ errorMessage_crm }}</div>
                </div>
              </div>

              <div class="form-row-submit-button" v-bind:style="{ textAlign: displayStyle}">
                <button
                  :disabled="scoreResult === undefined"
                  @click="SendToCrm()"
                  type="button"
                  class="btn btn-secondary"
                >
                  Submit to LiftFund
                </button>

                <div
                  v-if="submit_result == 'Success'"
                  v-bind:class="[submittingClass]"
                >
                  <p style="color:#008000;">Lead Submitted!</p>
                  <button
                    @click="ClearValues()"
                    :disabled="Object.keys(parameters).length < 2"
                    type="button"
                    v-bind:class="[clearClass]"
                  >
                    Clear values
                  </button>
                </div>
                <div
                  v-if="submit_result === 'Pending'"
                  v-bind:class="[submittingClass]"
                >
                  <p style="color:#008000;">Pending...</p>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
        <div v-if="rec_levelfi == 'Do Not Refer Lead'">
          <!--              <p style="color:#B22222;">Don’t Refer: A LiftFund business loan may not be a good fit for this client at this time.</p>-->
          <p>{{ DoNotRefer_Text }}</p>
        </div>

        <!--End Of Collapsible Submit div -->
        <div class="form-row">
          <div class="col mb-5"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DateFn from "date-fns";

import API from "@/services/api";
import PartnerTypeSupport from "@/services/partnertypesupport";
import CSVManager from "@/services/csvmanager";
import {
  AliasAndCalculate,
  FieldAliases,
  ContactAliases,
  PrepForCRMSubmit
} from "@/services/paramprocessor";
import enums from "@/services/enums";

export default {
  data() {
    return {
      enums: enums,
      FieldAliases: FieldAliases,
      ContactAliases: ContactAliases,
      parameters: { "Record ID": "999999" },
      errorMessage: undefined,
      errorMessage_crm: undefined,
      scoreResult: undefined,
      risklevel: undefined,
      ten_amount_levelfi: undefined,
      rec_levelfi: undefined,
      savedParams: undefined,
      modelParams: undefined,
      partner_type: undefined,
      partner_name: undefined,
      partner_email: undefined,
      referral_detail: undefined,
      levelFi_Header: undefined,
      levelFi_Instructions: undefined,
      DoNotRefer_Text: undefined,
      Refer_Text: undefined,
      Warning_Text: undefined,
      contact_data: {},
      calculated_fields: undefined,
      submit_result: undefined,
      existing_record: undefined,
      usage_payload: undefined,
      display_contact: true,
      displayStyle: 'left',
      submittingClass: 'col-sm-8 offset-sm-4',
      clearClass: 'btn btn-secondary ml-3',
      userIsLiftFund: false
    };
  },
  mounted() {
    // Boot to login if not logged in
    if (!API.token) {
      this.$router.replace("/login");
    }

    /// Get the name of the user
    this.partner_name = API.GetPartnerName();

    /// Set the partner type in the data object
    this.partner_type = API.GetPartnerType();

    /// Set the partner type in the data object
    this.partner_email = API.GetPartnerEmail();

    /// Setting the Partner Type will populate the approprate text
    PartnerTypeSupport.SetPartnerText(this.partner_type);

    this.levelFi_Header = PartnerTypeSupport.levelFi_Header;
    this.levelFi_Instructions = PartnerTypeSupport.levelFi_Instructions;
    this.DoNotRefer_Text = PartnerTypeSupport.DoNotRefer_Text;
    this.Refer_Text = PartnerTypeSupport.Refer_Text;
    this.Warning_Text = PartnerTypeSupport.Warning_Text;

    /// Attempt to get the partner name from the email cuz i'm lazy and hate work
    let partner_name;
    try {
      partner_name = this.partner_email.split("@")[1].split(".")[0];
    } catch (error) {
      partner_name = this.partner_email;
    }

    //Check if the user is from lift fund and should have the ability to add lead details
    this.userIsLiftFund = ( this.partner_email.split("@")[1].split(".")[0].indexOf('liftfund') !== -1 );

    // Determine if the form should be displayed
    this.display_contact = ! ( window.location.search.length && window.location.search.indexOf('leadid') );
    this.displayStyle = ! this.display_contact ? 'center' : 'left';
    this.submittingClass = ! this.display_contact ? 'col-sm-12 mt-3' : this.submittingClass;
    this.clearClass = ! this.display_contact ? 'btn btn-secondary' : this.clearClass;

    // Create a usage record
    this.usage_payload = {
      referral_name: this.partner_name,
      referral_email: this.partner_email,
      partner_name: partner_name,
      partner_type: this.partner_type,
      count_levelfi_usage: 1
    };
  },
  methods: {
    async submit() {
      this.errorMessage = undefined;
      this.scoreResult = undefined;
      this.risklevel = undefined;
      this.ten_amount_levelfi = undefined;
      try {
        /// process the fields for modeling
        const aliased = AliasAndCalculate(this.parameters);
        // const result = await API.QueryModel({
        //   record_id: "record_id",
        //   data_list: [aliased]
        // });

        const result = await API.QueryModel({
          data: [aliased]
        });

        // Save the parameters in case they muck with them
        ///this.savedParams = JSON.parse(JSON.stringify(this.parameters));
        this.savedParams = JSON.parse(JSON.stringify(aliased));

        if (
          result.status === 200 &&
          result.data &&
          result.data.body.predict[0].score &&
          result.data.body.predict.length === 1
        ) {
          // /// Save the renamed model data into modelParams
          // this.modelParams = aliased

          console.log("SCORING");
          this.scoreResult = result.data.body.predict[0].score;

          /// Calculate the Maxed approved Loan Amount
          /// Complete population of the the recomendation parameters.
          /// Prepare payload
          let rec_params = {};
          rec_params.score = result.data.body.predict[0].score;
          rec_params.opp_fico_score = aliased.opp_fico_score;
          rec_params.opp_declared_household_income =
            aliased.opp_declared_household_income;
          rec_params.opp_declared_business_expenses =
            aliased.opp_declared_business_expenses;
          rec_params.opp_declared_business_total_income =
            aliased.opp_declared_business_total_income;
          /// this value is deleted after the alised step
          rec_params._personaldebt = parseInt(
            this.parameters["Monthly Personal Debt"]
          );

          /// Send data to server for Business Logic Calculations
          let calculated_fields = await API.getRecommendation({
            data: [rec_params]
          });

          calculated_fields = calculated_fields.data.body.data;
          calculated_fields = calculated_fields;
          /// Save the calulcated Fields

          this.calculated_fields = calculated_fields[0];

          this.scoreResult = result.data.body.predict[0].score;

          this.risklevel = this.calculated_fields.risk_level;
          this.ten_amount_levelfi = Math.min(
            this.calculated_fields.ten_amount_levelfi,
            aliased.total_loan_amount
          );
          this.rec_levelfi = this.calculated_fields.rec_levelfi;

          /// Populate he Recommendation text based on the content

          if (this.rec_levelfi == "Refer Lead") {
            this.Refer_Text = PartnerTypeSupport.Refer_Text;
          } else {
            this.Refer_Text = PartnerTypeSupport.DoNotRefer_Text;
          }

          /// Create a record of this score attempt
          try {
            await API.createUseageRecord(this.usage_payload);
          } catch (e) {
            console.log(e);
          }
        } else {
          throw new Error("Bad response from LevelFi API");
        }
      } catch (err) {
        this.errorMessage = err.message;
        console.log(err);

        if (this.errorMessage === "Request failed with status code 401") {
          this.errorMessage =
            "Your session has expired. Please log out and log back in to continue scoring an applicant.";
        }

        if (err.message === "Network Error") {
          this.errorMessage =
            "Your session has expired. Please log out and log back in to continue scoring an applicant.";
        }
      }
    }, /// End Submit Function

    // Sends the final data to the crm
    async SendToCrm() {
      this.errorMessage_crm = undefined;

      try {
        //////////////
        /// Ensure we have required fields
        //////////////
        // Ensure we have a First Name
        if (this.contact_data["First Name"] === undefined && this.display_contact ) {
          throw new Error("First Name is a required field");
        }

        // Ensure we have a Last Name
        if (this.contact_data["Last Name"] === undefined && this.display_contact ) {
          throw new Error("Last Name is a required field");
        }

        // Ensure we have a Phone number
        if (this.contact_data["Applicant Email"] === undefined && this.display_contact ) {
          throw new Error("Applicant Email is a required field");
        }

        // Ensure we have a Phone number
        if (this.contact_data["Applicant Phone"] === undefined && this.display_contact ) {
          throw new Error("Applicant Phone is a required field");
        }

        /// Let the user know we are working on it
        this.submit_result = "Pending";

        //// Prep the body data
        //// Prep Lead data
        let payload = {};

        /// Attempt to get the partner name from the email cuz i'm lazy and hate work
        let partner_name;
        let split_partner_name;
        try {
          split_partner_name = this.partner_email.split("@")[1].split(".")[0];

          // handling different business emails and corresponding Business Names for partner names
          // important note: partner_name is Referral Name in crm but this.partner_name is Lead Source Detail(which is currently what we want)
          // Suncoast
          if (split_partner_name === "suncoastcreditunion") {
            this.partner_name = "Suncoast Credit Union";
          }

          // Bank of America
          if (split_partner_name === "bofa") {
            this.partner_name = "Bank of America";
          }

          // Wells Fargo
          if (split_partner_name === "wf") {
            this.partner_name = "Wells Fargo";
          }

          // Goldman Sachs
          if (split_partner_name === "gsbank") {
            this.partner_name = "Goldman Sachs";
          }

          // Liftfund
          if (split_partner_name === "liftfund") {
            this.partner_name = "Liftfund";
          }

          // The Village Resource Group
          if (split_partner_name === "thevillageresourcegroup") {
            this.partner_name = "The Village Resource Group";
          }

          // Just
          if ( split_partner_name === "hellojust" ) {
            this.partner_name = "JUST";
          }

          // NavyArmy Community Credit Union
          if ( split_partner_name === "navyarmyccu" ) {
            this.partner_name = "NavyArmy Community Credit Union";
          }
        } catch (error) {
          partner_name = this.partner_email;
        }

        this.referral_name = API.GetPartnerName();

        payload["record_id"] = "record_id";

        // Named referral_name, but this is equivalent right now in CRM to Lead Source Detail or the Business Name
        payload["referral_email"] = this.partner_email;
        payload["partner_type"] = this.partner_type;

        // this partner_name is equivalent to the agent of the company's name, so for example Melva who works at Suncoast
        payload["partner_name"] = this.referral_name;

        // Add the referral detail data
        payload["referral_detail"] = ( this.userIsLiftFund && this.referral_detail !== undefined && this.referral_detail.length )
          ? this.referral_detail
          : this.partner_name;

        ///// Prep Data for LevelFi SubRecord

        //// Prep the model data
        /// Limit the data based on the Partner Type
        if (this.partner_type === "partial_submit") {
          var record_payload = {};
        } else if (this.partner_type === "complete_submit") {
          var record_payload = this.savedParams;
        } /// End of Limit based on Partner Type

        record_payload["record_id"] = "000singleupload";

        /// ADD in contact data
        record_payload["firstname"] = this.contact_data["First Name"] ? this.contact_data["First Name"] : '';
        record_payload["lastname"] = this.contact_data["Last Name"] ? this.contact_data["Last Name"] : '';
        record_payload["email"] = this.contact_data["Applicant Email"] ? this.contact_data["Applicant Email"] : '';
        record_payload["phone"] = this.contact_data["Applicant Phone"] ? this.contact_data["Applicant Phone"] : '';

        /// Prep the LevelFi Business Logic data from the recomendation
        record_payload["score"] = this.scoreResult;
        record_payload["risk_level"] = this.risklevel;
        record_payload["ten_amount_levelfi"] = this.ten_amount_levelfi;
        record_payload["ten_amount_cf"] = this.calculated_fields.ten_amount_cf;
        record_payload[
          "ten_amountfico"
          ] = this.calculated_fields.ten_amountfico;

        /// If it is a complete submitter, add in debt and cashflow data
        if (this.partner_type === "complete_submit") {
          /// Grab the Monthly Personal Debt from the user input
          record_payload["_personaldebt"] = Number(
            this.parameters["Monthly Personal Debt"]
          );
        } // End of partner type check for complete submitter

        // Pass uuid if it is set
        if ( window.location.search.length && window.location.search.indexOf('leadid') !== -1 ) {
          let param = new URL(window.location.href);
          record_payload["lead_guid"] = param.searchParams.get('leadid');
        }

        /// Add in the record data to to our payload
        payload["data"] = [record_payload];

        /// Send data to the endpoint and see what happens
        let crm_result = await API.crmPassthroughCongito(payload);

        if ( crm_result.data.statusCode === 200 ) {
          this.submit_result = "Success";
        } else {
          this.submit_result = '';
          this.errorMessage_crm = crm_result.data.message;
        }
      } catch (err) {
        this.submit_result = '';
        this.errorMessage_crm = err.message;
      }
    },

    ClearValues() {
      this.parameters = { "Record ID": "999999" };
      this.scoreResult = undefined;
      this.risklevel = undefined;
      this.ten_amount_levelfi = undefined;
      this.rec_levelfi = undefined;
      this.submit_result = undefined;
    },
    SaveFile() {
      const csv = CSVManager.GenerateSingleCSV(
        this.savedParams,
        this.scoreResult,
        this.risklevel,
        this.ten_amount_levelfi
      );
      const currenttime = DateFn.format(new Date(), "YYYY-MM-DD, HHmmss");
      API.DownloadFile("LevelFi Single " + currenttime + ".csv", csv);
    }
  }
};
</script>

<style>
.form-row {
  display: flex;
  justify-content: center;
  margin-right: 20px;
  margin-top: 20px;
}

.error-message {
  color: red;
}

.col-sm-4 {
  /* border: solid purple 1px; */
  display: flex;
  flex-direction: row;
  align-items: center;
}

.understanding-scores {
  margin: 0;
}
.field-indent {
  margin-right: 10px;
}

.login-form-single-upload {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
}

.login-form-single-upload-contact {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
}

.control-label {
  text-align: start;
  margin: 0.2vw;
  padding: 1px;
}

.add-client-contact-button {
  display: flex;
  justify-content: center;
}

.info-icon {
  width: 18px;
  height: 20px;
  margin: 0.2rem;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #17435e;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #17435e;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: #17435e;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
</style>



// WEBPACK FOOTER //
// src/components/SingleUpload.vue